import { create } from 'zustand'

const STORAGE_KEY = 'pc-sidebar-fixada'

function readStored(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false // localStorage indisponível: começa minimizada
  }
}

interface SidebarState {
  /** Desktop: `true` = sidebar aberta empurrando o conteúdo; `false` = só ícones (expande no hover). */
  fixada: boolean
  toggleFixada: () => void
}

export const useSidebarStore = create<SidebarState>((set, get) => ({
  fixada: readStored(),
  toggleFixada: () => {
    const fixada = !get().fixada
    try {
      localStorage.setItem(STORAGE_KEY, fixada ? '1' : '0')
    } catch {
      /* preferência só nesta sessão */
    }
    set({ fixada })
  },
}))
